export const SIGN_UP_WITH_XERO_URL = "sign_up_with_xero";
export const SIGN_UP_WITH_XERO_AUTHORIZE_URL = `${SIGN_UP_WITH_XERO_URL}/authorize_url`;
export const SIGN_UP_WITH_XERO_VERIFY_URL = `${SIGN_UP_WITH_XERO_URL}/verify`;
